import React from 'react';
import StarRating from '../../components/StarRating';
import QuizStepIndicator from '../../components/QuizStepIndicator';
import VideoQnA from './VideoQnA';

function QuizPanel({
  videoId,
  qna,
  selectedComponentIndex,
  totalStarCount,
  displayedStarCount,
  starCount,
  state,
  buttonLabel,
  onSelectStep,
  onAnswerEoc,
  onNext,
  eoc,
}) {
  const stepDisabled = state === 'TAKEAWAYS_SHOWN' || !eoc;

  return (
    <div className="w-full rounded-xl p-4 mt-4 border-2 border-pastelgreen bg-white">
      <div className="mx-2">
        {selectedComponentIndex >= 1 && selectedComponentIndex <= qna.length && (
          <>
            <div className="flex justify-between items-center gap-3 mb-4">
              <QuizStepIndicator
                currentStep={selectedComponentIndex}
                numSteps={qna.length}
                onClicks={qna.map((_, index) => () => onSelectStep(index))}
                stepText="Question"
              />
              {totalStarCount > 0 && (
                <div className="inline-block bg-yellow-300 text-black px-2 py-1 rounded-full text-sm shrink-0">
                  ⭐ {displayedStarCount}
                </div>
              )}
            </div>
            {qna.map((qnaItem, index) => (
              <div
                key={index}
                style={{
                  display: selectedComponentIndex === index + 1 ? 'block' : 'none',
                }}
              >
                <VideoQnA
                  videoId={videoId}
                  qna={qnaItem}
                  onEoc={onAnswerEoc}
                />
              </div>
            ))}
          </>
        )}

        <div className="flex mt-8">
          <button
            className={`${stepDisabled ? 'bg-gray-400' : 'bg-blue-500'} text-white py-2 px-4 rounded`}
            disabled={stepDisabled}
            onClick={onNext}
          >
            {buttonLabel}
          </button>
          <div className="ml-2">
            <StarRating rating={starCount} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuizPanel;
